(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.candy-404');
    if (!root) return;

    const input = root.querySelector('#Candy404Search');
    const panel = root.querySelector('#Candy404Suggestions');
    const status = root.querySelector('[data-candy-404-status]');
    const back = root.querySelector('[data-candy-404-back]');
    const searchUrl = root.dataset.searchUrl || '/search';
    const base = window.Shopify?.routes?.root || '/';
    const predictiveBase = root.dataset.predictiveSearchUrl || `${base}search/suggest`;
    const predictiveUrl = predictiveBase.endsWith('.json') ? predictiveBase : `${predictiveBase}.json`;
    let timer;
    let controller;

    if (back && document.referrer) {
      try {
        const ref = new URL(document.referrer);
        if (ref.origin === window.location.origin && ref.pathname !== window.location.pathname) {
          back.hidden = false;
          back.addEventListener('click', () => window.history.back());
        }
      } catch (error) {}
    }

    if (!input || !panel) return;

    const announce = (message) => {
      if (status) status.textContent = message;
    };

    const getOptions = () => Array.from(panel.querySelectorAll('[role="option"]'));

    const hide = () => {
      panel.hidden = true;
      panel.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      announce('');
    };

    const show = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const addLabel = (text) => {
      const label = document.createElement('div');
      label.className = 'candy-404__suggestions-label';
      label.textContent = text;
      panel.appendChild(label);
    };

    const addCollection = (collection) => {
      const link = document.createElement('a');
      link.className = 'candy-404__suggestion candy-404__suggestion--collection';
      link.href = collection.url;
      link.setAttribute('role', 'option');

      const icon = document.createElement('span');
      icon.className = 'candy-404__suggestion-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '🍭';
      link.appendChild(icon);

      const title = document.createElement('strong');
      title.textContent = collection.title;
      link.appendChild(title);

      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      link.appendChild(arrow);
      panel.appendChild(link);
    };

    const addProduct = (product) => {
      const link = document.createElement('a');
      link.className = 'candy-404__suggestion';
      link.href = product.url;
      link.setAttribute('role', 'option');

      if (product.featured_image?.url) {
        const image = document.createElement('img');
        image.src = product.featured_image.url;
        image.alt = '';
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        link.appendChild(document.createElement('span'));
      }

      const title = document.createElement('strong');
      title.textContent = product.title;
      link.appendChild(title);

      const price = document.createElement('span');
      price.textContent = product.price || '';
      link.appendChild(price);
      panel.appendChild(link);
    };

    const addAllResults = (query, hasDirectResults) => {
      const link = document.createElement('a');
      link.className = 'candy-404__suggestions-all';
      link.href = `${searchUrl}?q=${encodeURIComponent(query)}`;
      link.setAttribute('role', 'option');

      const copy = document.createElement('span');
      copy.textContent = hasDirectResults ? 'Alle Suchresultate anzeigen' : 'Vollständige Suche öffnen';
      link.appendChild(copy);

      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      link.appendChild(arrow);
      panel.appendChild(link);
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) {
        hide();
        return;
      }

      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();

        try {
          const url = `${predictiveUrl}?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=hide`;
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('predictive-search');

          const data = await response.json();
          const products = (data?.resources?.results?.products || []).slice(0, 5);
          const collections = (data?.resources?.results?.collections || []).slice(0, 3);
          const directCount = products.length + collections.length;

          panel.replaceChildren();

          if (collections.length) {
            addLabel('Passende Kategorien');
            collections.forEach(addCollection);
          }

          if (products.length) {
            addLabel('Passende Produkte');
            products.forEach(addProduct);
          }

          addAllResults(query, directCount > 0);
          show();
          announce(directCount > 0 ? `${directCount} Suchvorschläge verfügbar.` : 'Keine direkten Treffer. Die vollständige Suche ist verfügbar.');
        } catch (error) {
          if (error.name !== 'AbortError') hide();
        }
      }, 180);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        hide();
        return;
      }

      if (panel.hidden) return;
      const options = getOptions();
      if (!options.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        options[0].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        options[options.length - 1].focus();
      }
    });

    panel.addEventListener('keydown', (event) => {
      const options = getOptions();
      const index = options.indexOf(event.target);
      if (index < 0) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        hide();
        input.focus();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        options[(index + 1) % options.length].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        options[(index - 1 + options.length) % options.length].focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) hide();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
